import type { PayloadAction } from '@reduxjs/toolkit';

import type { NetworkState } from './_state.type';

/** Network Reducer. */
export const networkReducer = {
  /**
   * Set Show state of Network Offline.
   *
   * @param {NetworkState} state State.
   * @param {PayloadAction<boolean>} action Action.
   */
  network_setShowNetworkOffline: (state: NetworkState, { payload }: PayloadAction<boolean>) => {
    state.network.offline = payload;
  },

  /**
   * Set Show state of Network Error.
   *
   * @param {NetworkState} state State.
   * @param {PayloadAction<boolean>} action Action.
   */
  network_setShowNetworkError: (state: NetworkState, { payload }: PayloadAction<boolean>) => {
    state.network.error = payload;
  },
};
